import Vue from 'vue';
import Component from 'vue-class-component';
import { goTop } from '@/global/utils';
let timer: any;
@Component
export default class MyMixin extends Vue {
  public activated() {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      goTop();
    }, 0);
  }
}
